export default __webpack_public_path__ + "static/media/receipt_logo.0e0e47da.jpeg";